require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-imagicasa-los-angeles-residence.json") })
        }
      }, "path---journal-imagicasa-los-angeles-residence");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-imagicasa-los-angeles-residence!./.cache/json/journal-imagicasa-los-angeles-residence.json
// module id = 499
// module chunks = 231608221292675